import React, { createContext, useEffect, useReducer } from 'react'
import axios from 'axios'
// import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import { Auth0Client } from '@auth0/auth0-spa-js'

import { auth0Config, auth0M2MConfig, backAPIUrl } from 'config.js'
import { MatxLoading } from 'app/components'
import { setLocalStorage, getLocalStorage, removeLocalStorage, localStorageName } from 'app/utils/utils.js'

let auth0Client = null

const initialAuthState = {
    isAuthenticated: false,
    isInitialised: false,
    user: null,
    token: null,
    permissions: null,
}
const reducer = (state, action) => {
    switch (action.type) {
        case 'INIT': {
            const { isAuthenticated, user, token, permissions } = action.payload

            return {
                ...state,
                isAuthenticated,
                isInitialised: true,
                user,
                token,
                permissions,
            }
        }
        case 'LOGIN': {
            const { user, token, permissions } = action.payload

            return {
                ...state,
                isInitialised: true,
                isAuthenticated: true,
                user,
                token,
                permissions,
            }
        }
        case 'LOGOUT': {
            return {
                ...state,
                isAuthenticated: false,
                user: null,
                token: null,
                permissions: null,
            }
        }
        default: {
            return { ...state }
        }
    }
}

const AuthContext = createContext({
    ...initialAuthState,
    method: 'AUTH0',
    loginWithPopup: () => Promise.resolve(),
    loginWithRedirect: () => Promise.resolve(),
    logout: () => {},
    getTokenM2M: () => Promise.resolve(),
    getUserPermissions: () => Promise.resolve(),
})

function ExceptionMessage(message){
    this.message = message
    this.name = 'customException'
}

export const AuthProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialAuthState)

    const loginWithPopup = async (options) => {
        await auth0Client.loginWithPopup(options)

        const isAuthenticated = await auth0Client.isAuthenticated()

        if (isAuthenticated) {
            const user = await auth0Client.getUser()

            const token_response = await getTokenM2M()
            
            if(token_response && token_response.status === 200){
                const token = token_response.data['access_token']

                const permissions_response = await getUserPermissions(user.email, token)

                if(permissions_response && permissions_response.status === 200){
                    try{
                        const userData = JSON.parse(permissions_response.data[0])

                        const permissions = userData.permissions
                        
                        setLocalStorage(localStorageName, JSON.stringify({
                            user: {
                                id: user.sub,
                                avatar: user.picture,
                                email: userData.email,
                                name: userData.keyuser || userData.email,
                                role: userData.profile,
                                company: userData.companyid
                            },
                            token,
                            permissions
                        }))
                        
                        dispatch({
                            type: 'LOGIN',
                            payload: {
                                user: {
                                    id: user.sub,
                                    avatar: user.picture,
                                    email: userData.email,
                                    name: userData.keyuser || userData.email,
                                    role: userData.profile,
                                    company: userData.companyid
                                },
                                token,
                                permissions,
                            },
                        })
                    }catch(e){
                        logout()
                        const customException = new ExceptionMessage('El usuario no tiene permisos')
                        throw customException
                    }
                }
            }
        }
    }

    const logout = (options) => {
        removeLocalStorage(localStorageName)
        dispatch({
            type: 'LOGOUT',
        })
        auth0Client.logout(options)
    }

    const getTokenM2M = () => {
        return axios.post(
                        `https://${auth0Config.domain}/oauth/token`, 
                        JSON.stringify(auth0M2MConfig),
                        { headers: { 'content-type': 'application/json' } }
                    )
    }

    const getUserPermissions = (email, token) => {
        return axios.get(
                `${backAPIUrl.initialAPI}/user/by_email/${email}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` }
                }
            )
    }

    useEffect(() => {
        ;(async () => {
            try {
                auth0Client = new Auth0Client({
                    redirect_uri: window.location.origin,
                    ...auth0Config,
                })

                const userData = JSON.parse(getLocalStorage(localStorageName))

                if(userData && userData.user && userData.token){
                    dispatch({
                        type: 'LOGIN',
                        payload: {
                            user: userData.user,
                            token: userData.token,
                            permissions: userData.permissions,
                        },
                    })
                }else{
                    dispatch({
                        type: 'INIT',
                        payload: {
                            isAuthenticated: false,
                            user: null,
                            token: null,
                            permissions: null,
                        },
                    })
                }
            } catch (err) {
                console.error(err)
                dispatch({
                    type: 'INIT',
                    payload: {
                        isAuthenticated: false,
                        user: null,
                        token: null,
                        permissions: null,
                    },
                })
            }
        })()
    }, [])

    if (!state.isInitialised) {
        return <MatxLoading />
    }

    return (
        <AuthContext.Provider
            value={{
                ...state,
                method: 'AUTH0',
                loginWithPopup,
                logout,
                getTokenM2M,
                getUserPermissions,
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext
